import React, { useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { LoadingScreen } from "Components";
import { CreateAttribute } from "./CreateAttribute";
import { authService } from "Service/Axios";
import { formatDateWithFullMonth } from "Utils";
import { DELETE_PROJECT_ATTRIBUTE_URL } from "Constant/api";
import { useAttributeList } from "Constant/apiHooks";
import { paths } from "Constant/paths";

export const Attributes = () => {
  const { t } = useTranslation();
  const { projectList } = useOutletContext();

  const [showCreateAttribute, setShowCreateAttribute] = useState(false);
  const [showCopyAttribute, setShowCopyAttribute] = useState(false);
  const [selectedAttribute, setSelectedAttribute] = useState(null);

  const {
    attributeList,
    loading: attributeLoading,
    fetchAttributeList,
  } = useAttributeList();

  // Toggle
  const toggleCreateAttribute = (attribute) => {
    if (attribute) {
      setSelectedAttribute(attribute);
    } else {
      setSelectedAttribute(null);
    }
    setShowCreateAttribute(!showCreateAttribute);
  };

  const toggleCopyAttribute = (attribute) => {
    if (attribute) {
      setSelectedAttribute(attribute);
    } else {
      setSelectedAttribute(null);
    }
    setShowCopyAttribute(!showCopyAttribute);
  };

  // Handle
  const onDeleteAttribute = async (gid) => {
    try {
      const data = {
        gid,
      };
      const response = await authService(
        DELETE_PROJECT_ATTRIBUTE_URL,
        "POST",
        data
      );
      if (response.success) {
        fetchAttributeList();
        toast.success(
          t("common.messages.notification.success.deleteAttribute")
        );
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error("common.messages.notification.failed.somethingWentWrong");
    }
  };

  return (
    <>
      <div className="attributes">
        <div className="d-flex align-items-center mb-3">
          <h4 className="admin-sub-title">{t("common.button.attributes")}</h4>
          <div className="ms-auto">
            <button
              className="btn btn-primary"
              type="button"
              onClick={() => toggleCreateAttribute()}
            >
              <i className="bx bx-plus"></i>{" "}
              {t("common.button.createAttribute")}
            </button>
          </div>
        </div>
        <div className="table-container mb-4 max-h-700">
          <table className="table table-bordered">
            <thead className="table-light position-sticky top-0 z-20">
              <tr>
                <th>{t("common.label.name")}</th>
                <th>{t("common.label.createdAt")}</th>
                <th>{t("common.label.project")}</th>
                <th>{t("common.label.stages")}</th>
                <th className="text-center">{t("common.label.action")}</th>
              </tr>
            </thead>
            <tbody>
              {attributeLoading ? (
                <tr className="loading-screen">
                  <td colSpan={5}>
                    <LoadingScreen />
                  </td>
                </tr>
              ) : (
                attributeList &&
                attributeList.length > 0 &&
                attributeList.map((attribute) => (
                  <tr key={attribute.gid}>
                    <td>{attribute.name}</td>
                    <td>
                      {attribute.createdAt &&
                        formatDateWithFullMonth(attribute.createdAt)}
                    </td>
                    <td>{attribute.project && attribute.project.name}</td>
                    <td>
                      {/* {attribute.attributes &&
                      convertLinkObjectListToJoin(attribute.attributes)} */}
                    </td>
                    <td>
                      <div className="d-flex justify-content-center align-items-center gap-1">
                        <Link
                          to={`${paths.admin.settings.attributesDetails}/${attribute.gid}`}
                          className="button edit btn btn-transparent px-1 text-primary-500"
                        >
                          <i className="bx bx-show-alt"></i>
                        </Link>
                        <button
                          type="button"
                          className="button edit btn btn-transparent px-1 text-green-500"
                          onClick={() => toggleCreateAttribute(attribute)}
                        >
                          <i className="bx bxs-pencil"></i>
                        </button>
                        <button
                          type="button"
                          className="button edit btn btn-transparent px-1 text-primary-500"
                          onClick={() => toggleCopyAttribute(attribute)}
                        >
                          <i className="bx bxs-copy"></i>
                        </button>
                        <button
                          type="button"
                          className="button edit btn btn-transparent px-1 text-red-500"
                          onClick={() => onDeleteAttribute(attribute.gid)}
                        >
                          <i className="bx bx-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {showCreateAttribute && (
        <CreateAttribute
          show={showCreateAttribute}
          selectedData={selectedAttribute}
          toggle={toggleCreateAttribute}
          fetchList={fetchAttributeList}
          projectList={projectList}
        />
      )}

      {showCopyAttribute && (
        <CreateAttribute
          show={showCopyAttribute}
          isCopy
          selectedData={selectedAttribute}
          toggle={toggleCopyAttribute}
          fetchList={fetchAttributeList}
          projectList={projectList}
        />
      )}
    </>
  );
};
